import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NetworkConnection } from './models/network-connection';

@Injectable()
export class NetworkConnectionService {

    private subject = new BehaviorSubject<NetworkConnection>(
        this.emptyMessage()
    );

    constructor() { }

    emptyMessage() {
        return {
            description: '',
            isConnectedClass: '',
            iconClass: '',
            isConnected: true
        };
    }

    sendMessage(message: NetworkConnection) {
        this.subject.next({ description: message.description, isConnectedClass: message.isConnectedClass, iconClass: message.iconClass, isConnected: message.isConnected });
    }

    clearMessage() {
        this.subject.next(this.emptyMessage());
    }

    getMessage(): Observable<NetworkConnection> {
        return this.subject.asObservable();
    }
}
